import Request from './index.js'
let url = ""
if (window.location.host == 'xz.giant.com.cn') {
  url = "https://xz.giant.com.cn/cloudDriver"// 测试
} else {
  url = "https://xz-test.giant.com.cn/cloudDriver"//正式 
}
export const request = new Request({
  baseURL: url,
  timeout: 5000
})